import "./App.css";
import { Samtykkeskjema } from "./Samtykkeskjema";

function App() {
  return (
    <div>
      <Samtykkeskjema />
    </div>
  );
}

export default App;
